import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';

interface MobileSubPageHeaderProps {
  title: string;
  subtitle?: string;
  onBack: () => void;
  action?: React.ReactNode;
}

export const MobileSubPageHeader: React.FC<MobileSubPageHeaderProps> = ({
  title,
  subtitle,
  onBack,
  action,
}) => {
  return (
    <>
      {/* Fixed Header */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          pt: 'env(safe-area-inset-top, 0px)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 1,
            py: 1,
            minHeight: subtitle ? 72 : 56,
          }}
        >
          <IconButton onClick={onBack} sx={{ mr: 0.5 }}>
            <BackIcon />
          </IconButton>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600} noWrap>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary" noWrap>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action && (
            <Box sx={{ ml: 1, flexShrink: 0 }}>
              {action}
            </Box>
          )}
        </Box>
      </Box>
      {/* Spacer for fixed header */}
      <Box sx={{ height: `calc(env(safe-area-inset-top, 0px) + ${subtitle ? 72 : 56}px)`, flexShrink: 0 }} />
    </>
  );
};
